import { LocationInput, LocationType, Provider, Role } from 'graphql/generated/graphqlTypes';
import {
  ADD_LOCATION,
  ADD_REST_API_KEY,
  ADD_VISITOR_GROUP_WITH_RETAIL,
  ASSIGN_TO_ACCESS_GRANTS,
  CHOOSE_PROVIDER,
  DELETE_DOOR_BY_ID,
  DELETE_LOCATION,
  DELETE_REST_API_KEY,
  SET_INSTALLER,
  SET_IS_ADMIN_FOR_GROUP,
  SET_VISITOR_BY_ID,
  UNASSIGN_TO_ACCESS_GRANTS,
  UNSET_INSTALLER_BY_ID,
  UPDATE_ACCESS_GRANT_WITH_IS_OFFICE_MODE_ENABLED,
  UPDATE_DOOR_WITH_LOCATIONS,
  UPDATE_DOOR_WITH_OFFICE_MODE,
  UPDATE_LOCATION,
  UPDATE_REST_API_KEY,
  UPDATE_VISITOR_GROUP_WITH_RETAIL
} from 'graphql/mutations';
import {
  ADD_DEVICE_GROUP,
  ADD_VISITOR_WITH_ROLE,
  ASSIGN_DEVICE_GROUP_TO_ACCESS_GRANTS,
  ASSIGN_DEVICE_TO_ACCESS_GRANTS,
  ASSIGN_DOOR_TO_LOCATIONS,
  BLOCK_ACCESS_CARD,
  BULK_ADD_VISITORS_TO_VISITOR_GROUPS,
  BULK_ASSIGN_VISITOR_ROLES,
  BULK_DELETE_VISITORS,
  DELETE_DEVICE_GROUP,
  DELETE_QR_CODE_VISIT,
  DELETE_VISITOR_BY_ID,
  DELETE_VISITOR_GROUP_BY_ID,
  SEND_INVITATION_FOR_MOBILE_DEVICE_BY_ID,
  SET_VISITOR_BY_ID_WITH_ROLE,
  UNASSIGN_DEVICE_FROM_ACCESS_GRANTS,
  UNASSIGN_DEVICE_GROUP_FROM_ACCESS_GRANTS,
  UNREGISTER_MOBILE_DEVICE_BY_ID,
  UPDATE_ACCESS_GRANT,
  UPDATE_DEVICE_GROUP,
  UPDATE_DOOR_INFO,
  UPDATE_VISITOR_GROUP_DETAILS_V2
} from 'graphql/v2/mutations';
import { mockedAddRestAPIKeyDataForMutation } from 'mocks/graphqlApollo/mutation/addRestAPIKey';
import { mockedBlockNfcCardDataForMutation } from 'mocks/graphqlApollo/mutation/blockNfcCard';
import { mockedBulkAddVisitorsToVisitorGroupsData } from 'mocks/graphqlApollo/mutation/bulkAddVisitorsToVisitorGroups';
import { mockedBulkAssignVisitorRolesData } from 'mocks/graphqlApollo/mutation/bulkAssignVisitorRoles';
import { mockedBulkDeleteVisitorsData } from 'mocks/graphqlApollo/mutation/bulkDeleteVisitors';
import {
  mockedChooseCognitoPrividerDataForQuery,
  mockedChooseEntraPrividerDataForQuery
} from 'mocks/graphqlApollo/mutation/chooseProvider';
import { mockedDeleteQrCodeVisitData } from 'mocks/graphqlApollo/mutation/deleteQrCodeVisit';
import { mockedDeleteRestAPIKeyDataForMutation } from 'mocks/graphqlApollo/mutation/deleteRestAPIKey';
import { mockedUpdateRestAPIKeyDataForMutation } from 'mocks/graphqlApollo/mutation/updateRestAPIKey';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';
import {
  mockedAddDeviceGroupDataForMutation,
  mockedAddLocationWithDoorsDataForMutation
} from '../graphqlApollo/mutation/addLocationWithDoors';
import { mockedAddVisitorGroupDataForMutation } from '../graphqlApollo/mutation/addVisitorGroupCoContractor';
import { mockedAddVisitorWithRoleDataForMutation1 } from '../graphqlApollo/mutation/addVisitorWithRole';
import {
  mockedAssignToAccessGrantsDataForCoContractorsDoor1,
  mockedAssignToAccessGrantsDataForCoContractorsDoor2,
  mockedAssignToAccessGrantsDataForCoContractorsTestGroup1,
  mockedAssignToAccessGrantsDataForCoContractorsTestGroup2,
  mockedAssignToAccessGrantsDataForMutation,
  mockedAssignToAccessGrantsDataForMutation1,
  mockedAssignToAccessGrantsDataForMutation2,
  mockedAssignToAccessGrantsDataForMutationDoor0,
  mockedAssignToAccessGrantsDataForMutationTestGroup1
} from '../graphqlApollo/mutation/assignToAccessGrants';
import {
  mockedDeleteDoorByIdDataForMutation,
  mockedDeleteDoorByIdDataForMutation1
} from '../graphqlApollo/mutation/deleteDoorById';
import {
  mockedDeleteDeviceGroupDataForMutation,
  mockedDeleteLocationDataForMutation
} from '../graphqlApollo/mutation/deleteLocation';
import { mockedDeleteVisitorByIdDataForMutation } from '../graphqlApollo/mutation/deleteVisitorById';
import { mockedDeleteVisitorGroupDataForMutation } from '../graphqlApollo/mutation/deleteVisitorGroup';
import { mockedSetInstallerDataForMutation } from '../graphqlApollo/mutation/setInstaller';
import { mockedSetIsAdminForGroupDataForMutation } from '../graphqlApollo/mutation/setIsAdminForGroup';
import {
  mockedSetVisitorDataForMutation,
  mockedUpdateInstallerDataForMutation
} from '../graphqlApollo/mutation/setVisitorById';
import { mockedSetVisitorWithRoleDataForMutation } from '../graphqlApollo/mutation/setVisitorByIdWithRole';
import {
  mockedUnassignToAccessGrantsDataForCoContractorsDoor,
  mockedUnassignToAccessGrantsDataForCoContractorsLocation,
  mockedUnassignToAccessGrantsDataForMutation,
  mockedUnassignToAccessGrantsDataForMutation1,
  mockedUnassignToAccessGrantsDataForMutation2,
  mockedUnassignToAccessGrantsDataForMutationDoor1,
  mockedUnassignToAccessGrantsDataForMutationTestGroup1
} from '../graphqlApollo/mutation/unassignToAccessGrants';
import { mockedUnregisterMobileDeviceDataForMutation } from '../graphqlApollo/mutation/unregisterMobileDevice';
import { mockedUnsetInstallerDataDataForMutation } from '../graphqlApollo/mutation/unsetInstallerById';
import {
  mockedUpdateAccessGrantForMutation1,
  mockedUpdateAccessGrantForMutation2
} from '../graphqlApollo/mutation/updateAccessGrant';
import { mockedUpdateAccessGrantWithIsOfficeModeForMutation1 } from '../graphqlApollo/mutation/updateAccessGrantWithIsOfficeModeEnabled';
import {
  mockedUpdateDoorInfoDataForMutation,
  mockedUpdateDoorWithOfficeModeDataForMutation
} from '../graphqlApollo/mutation/updateDoor';
import {
  mockedAssignDoorToLocationsDataForMutationController1,
  mockedAssignDoorToLocationsDataForMutationDoor0,
  mockedAssignDoorToLocationsDataForMutationDoor1,
  mockedUpdateDoorWithLocationsDataForMutation
} from '../graphqlApollo/mutation/updateDoorWithLocations';
import {
  mockedUpdateDeviceGroupDataForMutation,
  mockedUpdateLocationWithDoorsDataForMutation
} from '../graphqlApollo/mutation/updateLocationWithDoors';
import { mockedUpdateVisitorGroupDataForMutation } from '../graphqlApollo/mutation/updateVisitorGroup';
import {
  mockedUpdateVisitorGroupDetailsClearedMaxNumberOfMembersDataForMutation,
  mockedUpdateVisitorGroupDetailsDataForMutation
} from '../graphqlApollo/mutation/updateVisitorGroupDetails';

const testGroup1VisitorGroupAccessGrantIds = [
  'mockedAccessGrantIdInstallers',
  'mockedAccessGrantIdCleaners',
  'mockedAccessGrantIdCo-contractors',
  'mockedAccessGrantIdAdmins',
  'mockedAccessGrantIdEmployees',
  'mockedAccessGrantIdVisitor_group_1',
  'mockedAccessGrantIdVisitor_group_2',
  'mockedAccessGrantIdVisitor_group_3',
  'mockedAccessGrantIdVisitors'
];

export const mutations = [
  {
    request: {
      query: BULK_ADD_VISITORS_TO_VISITOR_GROUPS,
      variables: {
        input: {
          visitorIds: ['mockedVisitorIdExternalUser1'],
          memberships: [{ visitorGroupId: 'mockedVisitorGroupIdExternalUsers1', role: 'NONE' }]
        }
      }
    },
    newData: () => ({
      data: mockedBulkAddVisitorsToVisitorGroupsData()
    })
  },
  {
    request: {
      query: BULK_ASSIGN_VISITOR_ROLES,
      variables: {
        input: {
          visitorIds: ['mockedVisitorIdExternalUser1'],
          roles: ['ADMIN']
        }
      }
    },
    newData: () => ({
      data: mockedBulkAssignVisitorRolesData()
    })
  },
  {
    request: {
      query: BULK_DELETE_VISITORS,
      variables: {
        input: {
          visitorIds: ['mockedVisitorIdExternalUser1']
        }
      }
    },
    newData: () => ({
      data: mockedBulkDeleteVisitorsData()
    })
  },
  {
    request: {
      query: UNREGISTER_MOBILE_DEVICE_BY_ID,
      variables: { visitorId: 'mockedAutomatedTestsUIAdminVisitorId', mobileDeviceId: 'mockedMobileDevice' }
    },
    result: { data: mockedUnregisterMobileDeviceDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_DOOR_WITH_OFFICE_MODE,
      variables: {
        doorId: 'mockedDoorId0',
        name: 'mockedDoorNameUpdated',
        locationId: 'mockedLocationId',
        officeMode: { scheduleType: 'weekSchedule', weekSchedule: [] }
      }
    },
    result: () => ({
      data: {
        updateDoor: mockedUpdateDoorWithOfficeModeDataForMutation.updateDoor
      }
    }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: DELETE_DOOR_BY_ID,
      variables: { doorId: 'mockedDoorId0' }
    },
    result: { data: mockedDeleteDoorByIdDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNSET_INSTALLER_BY_ID,
      variables: { visitorId: 'mockedVisitorIdInstaller1' }
    },
    result: { data: mockedUnsetInstallerDataDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: DELETE_VISITOR_BY_ID,
      variables: { visitorId: 'mockedVisitorIdExternalUser1' }
    },
    result: { data: mockedDeleteVisitorByIdDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_VISITOR_BY_ID_WITH_ROLE,
      variables: {
        visitorId: 'mockedExternalUserId',
        name: 'mockedExternalUserName',
        visitorGroupExternalIds: ['mockedVisitorGroupIdExternalUsers1']
      }
    },
    result: { data: mockedSetVisitorDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_VISITOR_BY_ID_WITH_ROLE,
      variables: {
        visitorId: 'mockedVisitorIdExternalUser1',
        name: 'mockedVisitorNameExternalUser1AfterUpdate',
        visitorGroupExternalIds: ['mockedVisitorGroupIdExternalUsers1']
      }
    },
    result: { data: mockedSetVisitorDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_VISITOR_BY_ID_WITH_ROLE,
      variables: {
        visitorId: 'mockedVisitorIdExternalUser6',
        name: 'mockedVisitorEmailExternalUser6Edited',
        visitorGroupMembership: [
          { role: 'EXTERNAL_GROUP_USER', visitorGroupExternalRef: 'mockedVisitorGroupExternalRefs2' }
        ]
      }
    },
    result: { data: mockedSetVisitorWithRoleDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_VISITOR_BY_ID_WITH_ROLE,
      variables: {
        visitorId: 'mockedVisitorIdExternalUser6',
        name: 'mockedVisitorEmailExternalUser6Edited',
        visitorGroupMembership: [{ role: Role.ExternalGroupUser, visitorGroupId: 'mockedVisitorGroupIdExternalUsers4' }]
      }
    },
    result: { data: mockedSetVisitorWithRoleDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_VISITOR_BY_ID,
      variables: {
        visitorId: 'mockedVisitorIdInstaller1',
        name: 'mockedVisitorNameInstaller1Updated',
        visitorGroupExternalRefs: ['mockedVisitorGroupExternalRefsInstallers']
      }
    },
    result: { data: mockedUpdateInstallerDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_INSTALLER,
      variables: {
        email: 'mockedInstallerEmailNew',
        name: 'mockedInstallerNameNew'
      }
    },
    result: { data: mockedSetInstallerDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_ACCESS_GRANT,
      variables: {
        accessGrantId: 'mockedAccessGrantWithDays',
        input: {
          scheduleType: 'weekSchedule',
          weekSchedule: [
            {
              dayName: 'monday',
              from: '08:00:00',
              to: '21:00:00'
            }
          ]
        }
      }
    },
    result: { data: mockedUpdateAccessGrantForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_ACCESS_GRANT,
      variables: {
        accessGrantId: 'mockedAccessGrantWithDays5',
        input: {
          scheduleType: 'weekSchedule',
          weekSchedule: [
            {
              dayName: 'sunday',
              from: '08:00:00',
              to: '21:00:00'
            },
            {
              dayName: 'saturday',
              from: '08:00:00',
              to: '21:00:00'
            }
          ]
        }
      }
    },
    result: { data: mockedUpdateAccessGrantForMutation2 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ADD_VISITOR_GROUP_WITH_RETAIL,
      variables: { name: 'co-contractors-new', maxNumberOfMembers: 2, type: VisitorGroupType.CoContractors }
    },
    result: { data: mockedAddVisitorGroupDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_VISITOR_GROUP_WITH_RETAIL,
      variables: {
        name: 'co-contractors1',
        visitorGroupId: 'mockedVisitorGroupIdExternalUsers1',
        maxNumberOfMembers: 3
      }
    },
    result: { data: mockedUpdateVisitorGroupDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ADD_VISITOR_WITH_ROLE,
      variables: {
        email: 'mockedExternalUserEmail',
        name: 'mockedExternalUserName',
        visitorGroupMembership: [
          {
            role: Role.ExternalGroupUser,
            visitorGroupId: 'mockedVisitorGroupIdExternalUsers4'
          }
        ]
      }
    },
    result: { data: mockedAddVisitorWithRoleDataForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: DELETE_VISITOR_GROUP_BY_ID,
      variables: {
        visitorGroupId: 'mockedVisitorGroupId1',
        withVisitors: true
      }
    },
    result: { data: mockedDeleteVisitorGroupDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_IS_ADMIN_FOR_GROUP,
      variables: {
        externalRef: 'mockedVisitorGroupExternalRef1',
        isAdmin: true
      }
    },
    result: { data: mockedSetIsAdminForGroupDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_ACCESS_GRANT_WITH_IS_OFFICE_MODE_ENABLED,
      variables: {
        accessGrantId: 'mockedAccessGrantId1',
        isOfficeModeEnabled: false
      }
    },
    result: { data: mockedUpdateAccessGrantWithIsOfficeModeForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: DELETE_DOOR_BY_ID,
      variables: { doorId: 'mockedDoorId1' }
    },
    result: { data: mockedDeleteDoorByIdDataForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ADD_LOCATION,
      variables: { location: { doorIds: [], name: 'mockedLocationName', type: LocationType.Manual } as LocationInput }
    },
    result: { data: mockedAddLocationWithDoorsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_LOCATION,
      variables: {
        id: 'mockedLocationId0',
        location: { doorIds: [], name: 'mockedUpdatedLocationName', type: LocationType.Manual } as LocationInput
      }
    },
    result: { data: mockedUpdateLocationWithDoorsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: DELETE_LOCATION,
      variables: { id: 'mockedAddedLocationId' }
    },
    result: { data: mockedDeleteLocationDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_DOOR_WITH_LOCATIONS,
      variables: {
        doorId: 'mockedDoorId0',
        locationIds: undefined,
        name: 'mockedDoorNameUpdated',
        officeMode: { scheduleType: 'weekSchedule', weekSchedule: [] }
      }
    },
    result: { data: mockedUpdateDoorWithLocationsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: [],
        locationIds: ['mockedLocationId']
      }
    },
    result: { data: mockedAssignToAccessGrantsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: ['mockedDoorId0'],
        locationIds: []
      }
    },
    result: { data: mockedAssignToAccessGrantsDataForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0', 'mockedAccessGrantId1', 'mockedAccessGrantId2'],
        doorIds: ['mockedDoorId0'],
        locationIds: []
      }
    },
    result: { data: mockedAssignToAccessGrantsDataForMutation2 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: [],
        locationIds: ['mockedLocationId']
      }
    },
    result: { data: mockedUnassignToAccessGrantsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },

  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: ['mockedDoorId0'],
        locationIds: []
      }
    },
    result: { data: mockedUnassignToAccessGrantsDataForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: [],
        locationIds: ['mockedLocationId']
      }
    },
    result: { data: mockedUnassignToAccessGrantsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0', 'mockedAccessGrantId1', 'mockedAccessGrantId2'],
        doorIds: ['mockedDoorId0'],
        locationIds: []
      }
    },
    result: { data: mockedUnassignToAccessGrantsDataForMutation2 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantIdCo-contractors'],
        doorIds: [],
        locationIds: ['TestGroup1']
      }
    },
    result: { data: mockedUnassignToAccessGrantsDataForCoContractorsLocation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantIdCo-contractors'],
        doorIds: ['mockedDoorId1'],
        locationIds: []
      }
    },
    result: { data: mockedUnassignToAccessGrantsDataForCoContractorsDoor },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantIdCo-contractors'],
        doorIds: ['mockedDoorId2'],
        locationIds: []
      }
    },
    result: { data: mockedUnassignToAccessGrantsDataForCoContractorsDoor },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantIdCo-contractors'],
        doorIds: [],
        locationIds: ['TestGroup1']
      }
    },
    result: { data: mockedAssignToAccessGrantsDataForCoContractorsTestGroup1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantIdCo-contractors'],
        doorIds: [],
        locationIds: ['TestGroup2']
      }
    },
    result: { data: mockedAssignToAccessGrantsDataForCoContractorsTestGroup2 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantIdCo-contractors'],
        doorIds: ['mockedDoorId1'],
        locationIds: []
      }
    },
    result: { data: mockedAssignToAccessGrantsDataForCoContractorsDoor1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantIdCo-contractors'],
        doorIds: ['mockedDoorId2'],
        locationIds: []
      }
    },
    result: { data: mockedAssignToAccessGrantsDataForCoContractorsDoor2 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ADD_REST_API_KEY,
      variables: {
        description: 'new-api-key'
      }
    },
    result: { data: mockedAddRestAPIKeyDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_REST_API_KEY,
      variables: {
        id: 'mock-key-1',
        description: 'updatedName'
      }
    },
    result: { data: mockedUpdateRestAPIKeyDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: DELETE_REST_API_KEY,
      variables: {
        id: 'mock-key-1'
      }
    },
    result: { data: mockedDeleteRestAPIKeyDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: CHOOSE_PROVIDER,
      variables: {
        provider: Provider.Cognito
      }
    },
    result: { data: mockedChooseCognitoPrividerDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: CHOOSE_PROVIDER,
      variables: {
        provider: Provider.Entra
      }
    },
    result: { data: mockedChooseEntraPrividerDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  ...['mockedUpcomingQrCodeVisitId1', 'mockedUpcomingQrCodeVisitId2', 'mockedUpcomingQrCodeVisitId3'].map((id) => ({
    request: {
      query: DELETE_QR_CODE_VISIT,
      variables: { qrCodeVisitId: id }
    },
    result: () => ({ data: mockedDeleteQrCodeVisitData(id) }),
    maxUsageCount: Number.POSITIVE_INFINITY
  })),
  {
    request: {
      query: UPDATE_DOOR_INFO,
      variables: {
        doorId: 'mockedDoorId0',
        name: 'door 0',
        officeMode: { scheduleType: 'weekSchedule', weekSchedule: [] }
      }
    },
    result: { data: mockedUpdateDoorInfoDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_DOOR_TO_LOCATIONS,
      variables: { doorId: 'mockedDoorId0', name: 'door 0', locationIds: [] }
    },
    result: { data: mockedAssignDoorToLocationsDataForMutationDoor0 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_DOOR_TO_LOCATIONS,
      variables: { doorId: 'mockedDoorId1', name: 'door 1', locationIds: ['TestGroup1'] }
    },
    result: { data: mockedAssignDoorToLocationsDataForMutationDoor1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_DOOR_TO_LOCATIONS,
      variables: {
        doorId: 'mockedDoorId5',
        name: 'Controller 1',
        locationIds: ['TestGroup2', 'TestGroup3', 'TestGroup1']
      }
    },
    result: { data: mockedAssignDoorToLocationsDataForMutationController1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_DEVICE_TO_ACCESS_GRANTS,
      variables: { doorIds: ['mockedDoorId0'], accessGrantIds: ['mockedAccessGrantId1'], locationIds: [] }
    },
    result: { data: mockedAssignToAccessGrantsDataForMutationDoor0 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNASSIGN_DEVICE_FROM_ACCESS_GRANTS,
      variables: { doorIds: ['mockedDoorId1'], accessGrantIds: ['mockedAccessGrantId1'], locationIds: [] }
    },
    result: { data: mockedUnassignToAccessGrantsDataForMutationDoor1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  ...testGroup1VisitorGroupAccessGrantIds.map((accessGrantId) => ({
    request: {
      query: ASSIGN_DEVICE_GROUP_TO_ACCESS_GRANTS,
      variables: { accessGrantIds: [accessGrantId], doorIds: [], locationIds: ['TestGroup1'] }
    },
    result: () => ({ data: mockedAssignToAccessGrantsDataForMutationTestGroup1(accessGrantId) }),
    maxUsageCount: Number.POSITIVE_INFINITY
  })),
  ...testGroup1VisitorGroupAccessGrantIds.map((accessGrantId) => ({
    request: {
      query: UNASSIGN_DEVICE_GROUP_FROM_ACCESS_GRANTS,
      variables: { accessGrantIds: [accessGrantId], doorIds: [], locationIds: ['TestGroup1'] }
    },
    result: () => ({ data: mockedUnassignToAccessGrantsDataForMutationTestGroup1(accessGrantId) }),
    maxUsageCount: Number.POSITIVE_INFINITY
  })),
  {
    request: {
      query: ADD_DEVICE_GROUP,
      variables: { location: { name: 'New group', doorIds: [] } }
    },
    result: { data: mockedAddDeviceGroupDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_DEVICE_GROUP,
      variables: { id: 'TestGroup1', location: { name: 'Test group 1', doorIds: ['mockedDoorId1'] } }
    },
    result: { data: mockedUpdateDeviceGroupDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: DELETE_DEVICE_GROUP,
      variables: { id: 'TestGroup2' }
    },
    result: { data: mockedDeleteDeviceGroupDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_VISITOR_GROUP_DETAILS_V2,
      variables: {
        input: {
          visitorGroupId: 'mockedVisitorGroupIdExternalUsers1',
          name: 'co-contractors1',
          maxNumberOfMembers: 3,
          isQrCodeVisitInviter: false,
          officeMode: {
            accessGrantId: 'mockedAccessGrantId1',
            isOfficeModeEnabled: false
          }
        }
      }
    },
    result: { data: mockedUpdateVisitorGroupDetailsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_VISITOR_GROUP_DETAILS_V2,
      variables: {
        input: {
          visitorGroupId: 'mockedVisitorGroupIdExternalUsers1',
          name: 'co-contractors1',
          maxNumberOfMembers: null,
          isQrCodeVisitInviter: false,
          officeMode: {
            accessGrantId: 'mockedAccessGrantId1',
            isOfficeModeEnabled: false
          }
        }
      }
    },
    result: { data: mockedUpdateVisitorGroupDetailsClearedMaxNumberOfMembersDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: BLOCK_ACCESS_CARD,
      variables: { uuid: '#0000000001', reason: 'Lost card' }
    },
    result: { data: mockedBlockNfcCardDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SEND_INVITATION_FOR_MOBILE_DEVICE_BY_ID,
      variables: { visitorId: 'mockedVisitorIdCleaner1', mobileDeviceId: 'mockedMobileDeviceCleaner1' }
    },
    result: () => ({ data: { sendInvitationForMobileDeviceById: true } }),
    maxUsageCount: Number.POSITIVE_INFINITY
  }
];
